module.exports = __webpack_public_path__ + "static/media/register_telegram.4e950801.svg";